import React from "react";

interface Props {
  label: string
  required: boolean
  id: string
  innerRef?: React.RefObject<HTMLDivElement>
}

const LabelledInput = (props: React.PropsWithChildren<Props>) => {
  return <>
    <div ref={props.innerRef} className="margin-bottom-small">
      <label htmlFor={props.id}>
        <span>{props.label}</span>
        {props.required && <span>*</span>}
      </label>
    </div>
    {props.children}
  </>;
};

export default LabelledInput;